import { Box, HStack, VStack, RadioGroup, Radio, Button } from "@chakra-ui/react";

import { StepDetailsBaseProps } from "../models/StepDetailsBaseProps";
import { useState } from "react";

export const SelectWizardType = (props: StepDetailsBaseProps) => {
    const {
        colorScheme = 'blue', 
        className,
        style,
        children,
        saveActiveStepState,
        stepsSavedState,
        title,
        description,
        stepIdx,
        selectedStepOptionValue, // the value of the selected option
        stepOptions,
    } = props;

    console.log({...props});

    const [selectedStepOption, setSelectedStepOption] = useState<string | null>(selectedStepOptionValue ?? '');

    const StepOptionsComponent = () => {
        return (
            <RadioGroup value={selectedStepOption ?? undefined} onChange={setSelectedStepOption}>
                <VStack align="start">
                    {stepOptions?.map(({ optionValue, label, enabled }, index) => (
                        <Radio 
                            key={index} 
                            value={optionValue?.toString()} 
                            isDisabled={!enabled}
                            mr={5}>
                            {label}
                        </Radio>
                    ))}
                </VStack>
            </RadioGroup>
        )
    }

    const renderStepContent = () =>  {
        
        return (
            <>
                <h4>Select Portfolio Type:</h4> 
                <Box px={0} mb={10} ml={10}>
                    <StepOptionsComponent/>
                </Box>
                <HStack ml={10}>
                    <Button 
                        onClick={() => saveActiveStepState(-1, {
                            stepIdx: -1
                        }) } 
                        colorScheme={colorScheme}>
                        Start Wizard
                    </Button>
                </HStack>
            </>
        );
    }

    return renderStepContent()
}
